import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router';
import RegisterSupplierInPaymentService from '../../SupplierPayment/components/RegisterSupplierInPaymentService';

type Props = RouteComponentProps<any>

class RegisterSupplierInPaymentServiceView extends Component<Props> {
    render() {
        return (
            <Grid container alignContent="center">
                <Grid item xs={12} sm={12} >
                    <RegisterSupplierInPaymentService />
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(RegisterSupplierInPaymentServiceView);